import { render, staticRenderFns } from "./GreenFitOutOnHoldHistory.vue?vue&type=template&id=a488a402&scoped=true&"
import script from "./GreenFitOutOnHoldHistory.vue?vue&type=script&lang=js&"
export * from "./GreenFitOutOnHoldHistory.vue?vue&type=script&lang=js&"
import style0 from "./GreenFitOutOnHoldHistory.vue?vue&type=style&index=0&id=a488a402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a488a402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a488a402')) {
      api.createRecord('a488a402', component.options)
    } else {
      api.reload('a488a402', component.options)
    }
    module.hot.accept("./GreenFitOutOnHoldHistory.vue?vue&type=template&id=a488a402&scoped=true&", function () {
      api.rerender('a488a402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/GreenFitOutOnHoldHistory.vue"
export default component.exports